import React from "react";
export var childrenToArray = function (children) {
  var newFirstChildren = [];
  return React.Children.forEach(children, function (child) {
    newFirstChildren.push(child);
  }), newFirstChildren;
};